import { NavigateFn, Project } from '../../../utils/interfaces/types';
import { useIntersectionObserver } from '../../../hooks/useIntersectionObserver';

export interface IProjectItem {
  navigate: NavigateFn;
  project: Project;
}

export function ProjectItem(props: IProjectItem) {
  const { ref, isVisible } = useIntersectionObserver<HTMLElement>();

  return (
    <article
      className={`project-item  ${isVisible ? 'is-visible' : ''}`}
      ref={ref}
    >
      {/* ── Thumbnail ── */}
      <div
        className="project-item__image"
        onClick={() => props.navigate('project', props.project.id)}
      >
        {props.project.thumbnailImage ? (
          <img src={props.project.thumbnailImage} alt={props.project.title} />
        ) : (
          // Placeholder until real assets are added
          <div
            className="img-placeholder"
            style={{
              height: '100%',
              minHeight: '280px',
              background: props.project.id === 2 ? '#1a1a1a' : '#ccc',
            }}
          >
            <span style={{ color: props.project.id === 2 ? '#555' : '#888' }}>
              {props.project.title}
            </span>
          </div>
        )}
      </div>

      {/* ── Info ── */}
      <div className="project-item__info">
        <h3 className="project-item__title">{props.project.title}</h3>
        <p className="project-item__subtitle">
          {props.project.subtitle.split('\n').map((line, i) => (
            <span key={i}>
              {line}
              <br />
            </span>
          ))}
        </p>
        <button
          className="project-item__plus"
          onClick={() => props.navigate('project', props.project.id)}
        >
          + <span className="project-item__plus__text">Case study</span>
        </button>
      </div>
    </article>
  );
}
